import styled from 'styled-components'

const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: inherit;
`;

export default Title